<template>
    <Structure_Header_Col2 icon="fa-image">
        <template v-slot:col-1>
            <Header_Name
                :name="interactiveImage.name"
                type="Interactive Image"
                @save="saveName"
            />
        </template>
        <template v-slot:col-2>
            <Header_Tools
                :undo-active="interactiveImage.historyUndoIsActive()"
                :redo-active="interactiveImage.historyRedoIsActive()"
                :type="interactiveImage.getObjectType()"
                @undo="$emit('undo')"
                @redo="$emit('redo')"
                class="relative"
            >
                <div class="hr-v"></div>
                <div class="relative">
                    <btn square v-for="(chapter,key) in interactiveImage.chaptersGetSaved()" :key="key"
                         :class="[interactiveImage.chapterIsActive(key) ? 'active' : '', 'pic']"
                         @click="interactiveImage.chapterSetActive(key,false)" ref="btn-chapters"
                    >
                        {{ key + 1 }}
                    </btn>
                    <div class="chapter-title">
                        <div class="chapter-bulle pos-bottom" ref="chapter-title">
                            <div class="pic"></div>
                            {{ interactiveImage.chapterGetCurrent().title }}
                        </div>
                    </div>
                    <btn square @click="interactiveImage.chapterAdd()">
                        <tooltip :text="$t('Add new chapter')" delay="0.5s" position="bottom">
                            <i class="fal fa-plus"></i>
                        </tooltip>
                    </btn>
                </div>
            </Header_Tools>
        </template>
    </Structure_Header_Col2>
</template>

<script>
import Btn from "@/modules/buttons/btn";
import {interactiveImage} from "@/class/interactive-image/interactiveImage";
import InputText from "@/modules/input/input-text";
import Tooltip from "@/modules/tooltip";
import Header_Name from "@/views/header/Header_Name";
import Header_Tools from "@/views/header/Header_Tools";
import Structure_Header_Col3 from "@/views/structures/Structure_Header_Col3";
import Template from "@/layouts/Template";
import nav from "@/class/nav/nav";
import {saveContentOnglet} from "@/class/onglets/onglet";
import Structure_Header_Col2 from "@/views/structures/Structure_Header_Col2";

export default {
    name: "InteractiveImage_Header",
    components: {
        Structure_Header_Col2,
        Template, Structure_Header_Col3, Header_Tools, Header_Name, Tooltip, InputText, Btn
    },
    props: {
        interactiveImage: {type: Object, default: () => new interactiveImage()},
        saveState: {type: String},
    },
    data() {
        return {}
    },
    methods: {
        async saveName(newName) {
            this.interactiveImage.name = newName;
            nav.add(this.interactiveImage)
            
            await this.interactiveImage.patch('name')
            
            const story = saveContentOnglet.objectGet("story", this.interactiveImage.getStoryId())
            await story.loadContent()
            
            // this.interactiveImage.onglet.title = this.interactiveImage.name
        },
    },
}
</script>